import { ClientsGender } from '@app/pages/Clients/ClientsList/components/Filters/ClientsGender';

import { AdaptedFilter } from '@pages/Clients/ClientsList/components/Filters/AdaptedFilter';
import { AdaptedSelect } from '@pages/Clients/ClientsList/components/Filters/AdaptedSelect';
import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';
import { ClientsAge } from '@pages/Clients/ClientsList/components/Filters/ClientsAge';
import { ClientsBirthday } from '@pages/Clients/ClientsList/components/Filters/ClientsBirthday';
import { ClientsBirthdayLabel } from '@pages/Clients/ClientsList/components/Filters/ClientsBirthdayLabel';
import { ClientsClearButton } from '@pages/Clients/ClientsList/components/Filters/ClientsClearButton';
import { ClientsGenderLabel } from '@pages/Clients/ClientsList/components/Filters/ClientsGenderLabel';
import { ClientsSales } from '@pages/Clients/ClientsList/components/Filters/ClientsSales';
import { ClientsTags } from '@pages/Clients/ClientsList/components/Filters/ClientsTags';
import { ClientsTagsLabel } from '@pages/Clients/ClientsList/components/Filters/ClientsTagsLabel';
import { DatesTagContainer } from '@pages/Clients/ClientsList/components/Filters/DatesTagContainer';
import { Filters } from '@pages/Clients/ClientsList/components/Filters/Filters.main';
import { RangeLabel } from '@pages/Clients/ClientsList/components/Filters/RangeLabel';
import { RangeWithStartAndEnd } from '@pages/Clients/ClientsList/components/Filters/RangeWithStartAndEnd';
import { VisitsCategories } from '@pages/Clients/ClientsList/components/Filters/VisitsCategories';
import { VisitsClearButton } from '@pages/Clients/ClientsList/components/Filters/VisitsClearButton';
import { VisitsEmployees } from '@pages/Clients/ClientsList/components/Filters/VisitsEmployees';
import { VisitsPeriod } from '@pages/Clients/ClientsList/components/Filters/VisitsPeriod';
import { VisitsRecordsExistenceChild } from '@pages/Clients/ClientsList/components/Filters/VisitsRecordsExistence';
import { VisitsServices } from '@pages/Clients/ClientsList/components/Filters/VisitsServices';
export { VisitsTagsLabel } from '@pages/Clients/ClientsList/components/Filters/VisitsTagsLabel';
export { VisitsTags } from '@pages/Clients/ClientsList/components/Filters/VisitsTags';
export {
  Filters,
  VisitsPeriod,
  VisitsServices,
  VisitsEmployees,
  VisitsClearButton,
  ClientsGender,
  ClientsSales,
  RangeWithStartAndEnd,
  ClientsAge,
  ClientsGenderLabel,
  RangeLabel,
  VisitsCategories,
  ClientsClearButton,
  ClientsTags,
  ClientsTagsLabel,
  ClientsBirthday,
  ClientsBirthdayLabel,
  VisitsRecordsExistenceChild,
  AdaptedFilter,
  AdaptedSelect,
  ClientFilterTag,
  DatesTagContainer,
};
